import { useQuery } from "@tanstack/react-query";
import {
  EmissionFactorDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_EMISSION_FACTORS } from "../domain";

import { roleGuard } from "@api";
import { emissionFactorsApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";

const allowedRoles = [UserRole.Manager, UserRole.Owner];

export const ACTION_GET_EMISSION_FACTORS = "GET_EMISSION_FACTORS";

const getEmissionFactors = async (): Promise<EmissionFactorDto[]> => {
  const response =
    await emissionFactorsApi.emissionFactorsControllerGetEmissionFactors();

  return response.data;
};

export const useGetEmissionFactors = (
  user: UserProfileDto | null,
): {
  emissionFactors: EmissionFactorDto[] | undefined;
  emissionFactorsEnabled: boolean;
  isPendingGetEmissionFactors: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { isPending, data } = useQuery({
    queryKey: [DOMAIN_EMISSION_FACTORS, ACTION_GET_EMISSION_FACTORS, user?.role],
    queryFn: () => getEmissionFactors(),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    emissionFactors: data,
    emissionFactorsEnabled: enabled,
    isPendingGetEmissionFactors: isPending,
  };
};
